module.exports = __webpack_public_path__ + "assets/img/icon10.55194921.png";